import { useEffect, useState } from "react";
import { clearSession, getToken } from "./auth";

// export const BASE_URL = "http://localhost:4950";
export const BASE_URL = "https://backend.finitygrowth.com";


export function assetUrl(path) {
  if (!path) return "";
  const value = String(path);
  if (value.startsWith("http://") || value.startsWith("https://")) return value;
  return BASE_URL + (value.startsWith("/") ? value : "/" + value);
}

export function errorText(err) {
  if (!err || err.status === 401) return "";
  return err.message || "Request failed";
}

export async function api(path, options = {}) {
  const headers = {};
  let body = options.body;
  const isForm = typeof FormData !== "undefined" && body instanceof FormData;

  if (body && !isForm && typeof body !== "string") body = JSON.stringify(body);
  if (body && !isForm) headers["Content-Type"] = "application/json";

  if (options.auth !== false) {
    const token = getToken();
    if (token) headers.Authorization = "Bearer " + token;
  }

  let response;
  try {
    response = await fetch(BASE_URL + "/api/v1/admin" + path, {
      method: options.method || "GET",
      headers,
      body,
      cache: "no-store",
    });
  } catch (err) {
    const error = new Error("Cannot reach the server at " + BASE_URL);
    error.status = 0;
    error.errors = {};
    throw error;
  }

  const payload = await response.json().catch(() => ({}));

  if (response.status === 401) {
    clearSession();
    if (window.location.pathname !== "/admin/login") {
      window.location.assign("/admin/login");
    }
    const error = new Error(payload.message || "Please sign in");
    error.status = 401;
    error.errors = payload.errors || {};
    throw error;
  }

  if (!response.ok) {
    const error = new Error(payload.message || "Request failed");
    error.status = response.status;
    error.errors = payload.errors || {};
    throw error;
  }

  return payload;
}

export function useFetch(path) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(Boolean(path));
  const [error, setError] = useState("");
  const [errors, setErrors] = useState({});
  const [version, setVersion] = useState(0);

  useEffect(() => {
    if (!path) {
      setData(null);
      setLoading(false);
      setError("");
      setErrors({});
      return undefined;
    }

    let gone = false;
    setLoading(true);
    setError("");
    setErrors({});
    setData(null);

    api(path)
      .then((result) => {
        if (!gone) setData(result);
      })
      .catch((err) => {
        if (gone || err.status === 401) return;
        setError(err.message || "Request failed");
        setErrors(err.errors || {});
      })
      .finally(() => {
        if (!gone) setLoading(false);
      });

    return () => {
      gone = true;
    };
  }, [path, version]);

  return {
    data,
    loading,
    error,
    errors,
    reload() {
      setVersion((value) => value + 1);
    },
  };
}
